/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Phone/Fields/Type",
  isInvalid,
  onChange
  
}) {
let typesValueData = fromData.useDataValue({ viewPath,
context: 'types',
})
let newProfessionalPhoneTypeValueData = fromData.useDataValue({ viewPath,
context: 'new_professional',
path: 'phone.type',
})
let newProfessionalPhoneTypeIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_professional',
path: 'phone.type',
validate: fromValidate.textInput,
})
let newProfessionalPhoneTypeChangeData = fromData.useDataChange({ viewPath,
context: 'new_professional',
path: 'phone.type',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 flexBasis={1}
 flexGrow={1}
 data="types"
 from={typesValueData}
 data="new_professional.phone.type"
 validate="/Data/validate.js textInput"
 invalid={!newProfessionalPhoneTypeIsValidData}
 value={newProfessionalPhoneTypeValueData}
 onChange={newProfessionalPhoneTypeChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Type"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}